<template>
  <span class="issue-new-card" @click="$emit('click')">
    <span class="pulse-button"><v-icon left dark>person_add</v-icon>Add New</span>
  </span>
</template>

<script>
export default {};
</script>

<style>
.pulse-button {
  display: inline-flex;
  justify-content: center;
  width: 126px;
  max-width: 126px;
  height: 36px;
  /* line-height: 1.25rem; */
  font-size: 0.875rem;
  line-height: normal;
  color: white;
  border-radius: 28px;
  padding: 20px !important;
  font-weight: 500;
  letter-spacing: 0.0892857143rem;
  justify-content: center;
  outline: 0;
  white-space: nowrap;
  text-decoration: none;
  text-indent: 0.0892857143em;
  background: #f15e31;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(#f15e31, 0.5);
  -webkit-animation: pulse 1.5s infinite;
  align-items: center;
}
.pulse-button:hover {
  -webkit-animation: none;
  background: #f26c43;
}

@-webkit-keyframes pulse {
  0% {
    @include transform(scale(0.95));
  }
  70% {
    @include transform(scale(1));
    box-shadow: 0 0 0 50px rgba(#5a99d4, 0);
  }
  100% {
    @include transform(scale(0.9));
    box-shadow: 0 0 0 0 rgba(#5a99d4, 0);
  }
}
</style>
